import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { setActiveSpawnType, setHoverSpawnType, setSpawnTypes } from "@/domains/spawn/slice.ts";

export default () => {
  const [isShow, setIsShow] = useState(false);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.SelectSpawn.Show,
      async (request: typeof RegionShared.Cef.Requests.SelectSpawnShowRequest): Promise<void> => {
        dispatch(setSpawnTypes(request.spawnTypes));
        setIsShow(true);
      },
    );

    rpc.register(
      RegionShared.Cef.Events.SelectSpawn.SetActiveType,
      async (
        request: typeof RegionShared.Cef.Requests.SelectSpawnSetActiveTypeRequest,
      ): Promise<void> => {
        console.log("SET ACTIVE SPAWN TYPE", request.spawnType);
        dispatch(setActiveSpawnType(request.spawnType));
      },
    );

    rpc.register(
      RegionShared.Cef.Events.SelectSpawn.SetHoverType,
      async (
        request: typeof RegionShared.Cef.Requests.SelectSpawnSetHoverTypeRequest,
      ): Promise<void> => {
        console.log("SET HOVER SPAWN TYPE", request.spawnType);
        dispatch(setHoverSpawnType(request.spawnType));
      },
    );

    rpc.register(RegionShared.Cef.Events.SelectSpawn.Hide, async (): Promise<void> => {
      setIsShow(false);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.SelectSpawn.Show);
      rpc.unregister(RegionShared.Cef.Events.SelectSpawn.Hide);
      rpc.unregister(RegionShared.Cef.Events.SelectSpawn.SetActiveType);
      rpc.unregister(RegionShared.Cef.Events.SelectSpawn.SetHoverType);
    };
  }, [dispatch]);

  return {
    isShow,
  };
};
